/**
 * Service API pour l'authentification et les opérations générales admin
 * @module admin/services/adminApi
 */

import { apiGet, apiPost } from '../../../utils/api';

/**
 * Vérifie si le token d'authentification admin est valide
 * @returns {Promise<Object>} Réponse avec success et user si valide
 * @throws {Error} Si la vérification échoue
 */
export const verifyAdminAuth = async () => {
  return await apiGet('/admin/auth/verify');
};

/**
 * Déconnecte l'utilisateur admin
 * @returns {Promise<Object>} Réponse de déconnexion
 * @throws {Error} Si la déconnexion échoue
 */
export const logoutAdmin = async () => {
  return await apiPost('/admin/auth/logout');
};
